var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useFetch from "./useFetch.js";
function useApi(input, init) {
  const {
    i18n
  } = useTranslation();
  const effectiveOptions = useMemo(() => {
    return __spreadProps(__spreadValues({
      credentials: "include"
    }, init), {
      headers: __spreadValues({
        "x-dc-lang": i18n.language
      }, init == null ? void 0 : init.headers)
    });
  }, [i18n.language, init]);
  return useFetch(input, effectiveOptions);
}
export {
  useApi as default
};
